import React, {
    useState,
    useEffect,
    useLayoutEffect,
    useRef
} from 'react';
import { useQuery } from '@tanstack/react-query';

import * as UTILS from "../utils";
import * as QUERIES from "../query-functions";
import CardCarousel from '../components/card-carousel';
import LoadingIndicator from '../components/loading-indicator';

const UpcomingTickets = (props) => {

    const [upcomingTickets, setUpcomingTickets] = useState(props.upcomingTickets);
    
    const {
        isPending: ordersPending,
        data: ordersData,
    } = useQuery({
        queryKey: ['ordersData'],
        queryFn: QUERIES.getOrders,
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !props.upcomingTickets
    });

    useEffect(() => {
        if (!ordersData || props.upcomingTickets) return;

        const upcoming = UTILS.getUpcomingTickets(ordersData);
        setUpcomingTickets(upcoming);

    }, [ordersData]);

    if (ordersPending) return <LoadingIndicator />;
    if (!upcomingTickets?.length) return null;

    return (
        <CardCarousel cards={upcomingTickets} class="upcoming-tickets" title="Upcoming bookings" />
    );
};

export default UpcomingTickets;